import React from "react";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Card } from "@/components/common";
import { Phone, Mail, MessageCircle, Info } from "lucide-react";

export default function Assistenza() {
  return (
    <DashboardLayout title="Assistenza">
      <div className="max-w-2xl space-y-6">
        <Card className="space-y-4">
          <h3 className="font-bold text-[#102A2A]">Hai bisogno di aiuto?</h3>
          <p className="text-sm text-[#5C6B68]">Il nostro team è disponibile per informazioni organizzative sulle tue richieste e prenotazioni.</p>
          <div className="space-y-3">
            <a href="tel:+393882454770" className="flex items-center gap-3 p-4 rounded-xl bg-[#EAF3EF] hover:bg-[#E0EFEA] transition-colors">
              <span className="h-11 w-11 rounded-xl bg-[#087A73] text-white flex items-center justify-center"><Phone className="h-5 w-5" /></span>
              <div><p className="font-semibold text-[#102A2A]">Telefono</p><p className="text-sm text-[#5C6B68]">388 245 4770 (Lun-Ven 9-18)</p></div>
            </a>
            <a href="mailto:etruriacare@icloud.com" className="flex items-center gap-3 p-4 rounded-xl bg-[#EAF3EF] hover:bg-[#E0EFEA] transition-colors">
              <span className="h-11 w-11 rounded-xl bg-[#087A73] text-white flex items-center justify-center"><Mail className="h-5 w-5" /></span>
              <div><p className="font-semibold text-[#102A2A]">Email</p><p className="text-sm text-[#5C6B68]">etruriacare@icloud.com</p></div>
            </a>
          </div>
        </Card>
        <Card className="space-y-3">
          <div className="flex items-center gap-2"><MessageCircle className="h-5 w-5 text-[#25D366]" /><h3 className="font-bold text-[#102A2A]">Avvia una richiesta via WhatsApp</h3></div>
          <p className="text-sm text-[#5C6B68]">Puoi avviare una richiesta o chiedere informazioni organizzative tramite WhatsApp. Un nostro operatore ti guiderà nella prenotazione.</p>
          <a
            data-testid="whatsapp-start"
            href={`https://wa.me/393882454770?text=${encodeURIComponent("Ciao EtruriaCare, vorrei informazioni per prenotare una prestazione a domicilio ad Arezzo. (Non invio dati sanitari o clinici in questa chat.)")}`}
            target="_blank" rel="noopener noreferrer"
            onClick={() => { api.post("/track/whatsapp-click").catch(() => {}); }}
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb457] text-white rounded-xl h-12 px-5 font-semibold transition-colors w-full sm:w-auto justify-center"
          >
            <MessageCircle className="h-5 w-5" /> Scrivici su WhatsApp
          </a>
          <div className="flex items-start gap-2 bg-[#FBF0D6] border border-[#D99A00]/40 text-[#8a6400] rounded-xl px-4 py-3 text-sm">
            <Info className="h-4 w-4 mt-0.5 shrink-0" />
            WhatsApp va usato <strong>solo</strong> per informazioni organizzative e per avviare una richiesta. Non inserire mai diagnosi, referti, farmaci o altri dati sanitari nei messaggi.
          </div>
          <p className="text-xs text-[#5C6B68]/70">Numero dimostrativo. In futuro il canale sarà collegato a un provider WhatsApp Business autorizzato.</p>
        </Card>
      </div>
    </DashboardLayout>
  );
}
